<template>
  <div class="d-flex flex-column" style="height: 100%">
    <RewardsSummary />
    
    <Section v-if="!me.has_approved_w9" class="mt-2 mb-1 px-4">
      <div class="grey--text text--darken-2">
        Before you can begin earning or claiming rewards, you must 
        have a W-9 on file.
        <router-link :to="{ name: 'profile' }">Add now</router-link>.
      </div>
    </Section>

    <template v-if="me.has_approved_w9 || currentPageRewards.length>0">
      <div class="flex-grow-1" ref="scrollable" style="overflow-y: hidden">
        <RewardsList :rewards="currentPageRewards" style="overflow-y: auto"/>
      </div>

      <v-pagination v-model="page" color="grey lighten-1" class="mt-1" :length="pages" />
    </template>
  </div>
</template>

<script>
import RewardsList from './RewardsList'
import RewardsSummary from './RewardsSummary'
import { Section } from '@/components/pages'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RewardsBalanceMain',

  components: { RewardsList, RewardsSummary, Section },

  data: () => ({
    page: 1,
    pageSize: 0,
    lastPage: -1,
    lastOffset: -1,

    resizeObserver: null,

    uuid: Math.floor(Math.random() * 1_000_000),
  }),

  computed: {
    ...mapGetters('auth', ['me']),
    ...mapGetters('rewards', ['allRewards']),

    pages() {
      return this.pageSize == 0 ? 0 : Math.ceil(this.allRewards.item_count / this.pageSize)
    },

    currentPageRewards() {
      return this.allRewards.data
    },
  },

  watch: {
    page() {
      this.reload()
    },
  },

  methods: {
    ...mapActions('rewards', ['loadAllRewards']),
    
    reload() {
      if (this.page != this.lastPage || this.offset != this.lastOffset) {
        this.lastPage = this.page
        this.lastOffset = this.offset

        if (this.pageSize > 0 ) {
          this.loadAllRewards({
            limit: this.pageSize,
            offset: (this.page-1) * this.pageSize,
          })
        }
      }
    }
  },

  async mounted() {
    this.pageSize = Math.floor(this.$refs.scrollable.offsetHeight / 32)
    this.reload

    this.resizeObserver = new ResizeObserver(entries => {
      this.pageSize = Math.floor(entries[0].contentRect.height / 32)
      this.reload()
    })

    this.resizeObserver.observe(this.$refs.scrollable)
  },

  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.scrollable)
  }
}


</script>
